<div class="dialog-body" *ngIf = "data.type == 'alert' || !data.type ">
    <div class="dialog-header" mat-dialog-title><i class="fa fa-exclamation-circle" aria-hidden="true"></i></div>
    <div class="dialog-content dialog-whitspace">{{data.data}}</div>
    <div class="text-center">
        <button class="mx-1 dialogAction button" type="button" (click)="acceptMessage()">OK</button>
    </div>
</div>
<div class="dialog-body" *ngIf = "data.type == 'formContentAlert'">
    <div class="dialog-header" mat-dialog-title><i class="fa fa-exclamation-circle" aria-hidden="true"></i></div>
    <div class="dialog-content dialog-whitspace">{{data.data}}</div>
    <div class="dialogFooter">
        <button class="mx-1 dialogAction button" type="button" (click)="editForm()">Review form</button>
        <button class="mx-1 dialogAction button" type="button" (click)="continue()">Continue</button>
    </div>
</div>

<div class="dialog-body" *ngIf="data.type == 'SUCCESS'">
    <div class="dialog-content dialog-whitspace">{{data.data}}</div>
    <div class="text-center">
        <button class="mx-1 dialogAction button" type="button" (click)="acceptMessage()">OK</button>
    </div>
</div>

<div class="dialog-body" *ngIf="data.type == 'LeaveCall'">
    <div class="dialog-content dialog-whitspace">{{data.data}}</div>
    <div class="text-center">
        <button class="mx-1 dialogAction button" type="button" (click)="leaveCall()">Leave</button>
        <button class="mx-1 dialogAction button" type="button" (click)="stayOnCall()">Stay</button>
    </div>
</div>

<div class="dialog-body" *ngIf="data.type == 'ErrorOccured'">
    <!-- <div class="dialog-header" mat-dialog-title><i class="fa fa-exclamation-circle" aria-hidden="true"></i></div> -->
    <div class="dialog-content dialog-whitspace pb-0"><strong>{{data.errId}}</strong></div>
    <div class="dialog-content dialog-whitspace pt-0">{{data.data}}</div>
    <div class="text-center">
        <button class="mx-1 dialogAction button" type="button" (click)="errorOccouredOK()">OK</button>
        <!-- <button class="mx-1 dialogAction button" type="button" (click)="errorOccouredClose()">Cancel</button> -->
    </div>
</div>